module.exports = "/_next/static/images/refund_mobile-fd23c7d81c038358c589656dd429eccd.svg";